export const fallbackToNull = <T>(result: T | undefined): T | null => result ?? null;
